import { useSelector } from 'react-redux';
import type { WARootState } from '@/store/store';
import type { ViewingTagSelection } from '@/utils/viewingTagSelection';

export function useViewingTagSelection(): ViewingTagSelection {
  return useSelector(
    (state: WARootState) => state.viewingTag.selectedViewingTag,
  );
}
